import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { selectionByValue } from '~/features/base/utils/selectUtils';
import { DeliverableType } from '~/features/deliverables/constants/DeliverableType';
import { ALL } from '~/features/base/constants/filterOptions';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';

export const deliverablesTypes = [DeliverableType.BUNDLE, DeliverableType.CM4G, DeliverableType.APP, DeliverableType.DISTRO, DeliverableType.FILE];

export const deliverablesByDeviceType: Record<string, string[]> = {
    CM4: [DeliverableType.BUNDLE, DeliverableType.CM4G, DeliverableType.FILE],
    TBM3: [DeliverableType.APP, DeliverableType.DISTRO, DeliverableType.FILE],
    VCM: [DeliverableType.APP, DeliverableType.DISTRO, DeliverableType.FILE],
};
interface DeliverableTypeSelectProps {
    deliverableType?: string;
    hasError?: boolean;
    value: string;
    onChange: Function;
    withLabel?: boolean;
    label?: string | ReactNode;
    withAllOption?: boolean;
    deviceType?: string;
}

const DeliverableTypeSelect: React.FC<DeliverableTypeSelectProps> = ({
    hasError,
    value,
    onChange,
    withLabel,
    label,
    withAllOption, deviceType
}) => {

    const deliverablesTypesForSelection = deviceType ? deliverablesByDeviceType[deviceType] : deliverablesTypes;
    const deliverableTypeOptions = deliverablesTypesForSelection.map(d => ({
        id: d,
        label: d,
        value: d
    }));

    const deliverableTypes = !withAllOption ? deliverableTypeOptions : [{
        id: ALL,
        label: <FormattedMessage id={'intl-msg:overview.rollout.allDeliverablesTypeFilter'}/>,
        value: ALL
    }, ...deliverableTypeOptions];

    const options = selectionByValue(value)(deliverableTypes);

    return (
        <div>
            {!withLabel && <label className='control-label'>
                <FormattedMessage id='intl-msg:deliverableType'/>
            </label>}
            <SelectOTA
                hasError={hasError}
                value={[value]}
                options={options}
                label={withLabel && label}
                onChange={(selectedOption) => {
                    onChange(selectedOption?.value);
                }}
                placeholder={<FormattedMessage
                    id='intl-msg:deliverabletype.prompt'/>}/>
        </div>
    );
};

export default DeliverableTypeSelect;
